export default [
    {
        name: 'facts',
        sortField: 'facts',
        type: 'string',
        useInFilter: true,
        isDefault: true,
        defaultSearch: true

    }

]